/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  WebApiContactDtoContactDto,
} from '../models';
import {
    WebApiContactDtoContactDtoFromJSON,
    WebApiContactDtoContactDtoToJSON,
} from '../models';

export interface ApiContactPostRequest {
    webApiContactDtoContactDto?: WebApiContactDtoContactDto;
}

/**
 * 
 */
export class ContactApi extends runtime.BaseAPI {

    /**
     */
    async apiContactPostRaw(requestParameters: ApiContactPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Contact`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiContactDtoContactDtoToJSON(requestParameters.webApiContactDtoContactDto),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiContactPost(requestParameters: ApiContactPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiContactPostRaw(requestParameters, initOverrides);
    }

}
